import React from 'react';
import { SubNavContainer } from '@xo-union/tk-ui-sub-nav';
import { compose } from '@xo-union/react-css-modules';
import { SubNavLink } from './SubNavLink';
import styles from './subNav.scss';

interface Props {
  subNavNames: string[];
  activeTabIndex: number;
  onTabClick: (arg0: number) => void;
}

// overrides the union styles
const containerClasses = compose({
  'sub-nav-item-list': styles.container,
  'sub-nav-container': styles.subNavContainer,
});

export const SubNav: React.FC<Props> = ({ onTabClick, subNavNames, activeTabIndex }) => {
  const links = (
    <>
      {subNavNames.map((name, index) => (
        <SubNavLink
          active={activeTabIndex === index}
          onClickHandler={(): void => onTabClick(index)}
          index={index}
          name={name}
        />
      ))}
    </>
  );

  return <SubNavContainer classes={containerClasses} links={links} />;
};
